// Bridge between global beehiveConfig and module imports
declare global {
  interface Window {
    beehiveConfig: {
      config: {
        BEEHIVE_AZUREAD_TENANT_ID: string;
        BEEHIVE_AZUREAD_CLIENT_ID: string;
        BEEHIVE_AZUREAD_AUDIENCE: string;
        API_BASE_URL: string;
      };
    };
  }
}

// Access the global beehiveConfig and export its config
export const config = (window as any).beehiveConfig?.config || {
  BEEHIVE_AZUREAD_TENANT_ID: '',
  BEEHIVE_AZUREAD_CLIENT_ID: '',
  BEEHIVE_AZUREAD_AUDIENCE: '',
  API_BASE_URL: '',
};
